// extracted by mini-css-extract-plugin
export default {"wrapper":"CU-z","availablePromoMessagesLabel":"DU-z","promoMessageList":"EU-z","promoMessage":"FU-z","appliedPromoMessage":"GU-z","promoMessageAmount":"HU-z"};